import { useStore } from '@/store/yjsStore'
import { NODE_GAP_X, SET_NODE_WIDTH } from './canvasConstants'
import type { PlaceholderCharacterInfo } from '@/components/set/GeneratingSetContext'
import type { SubjectCanvasNode } from '@/types'

const SUBJECT_VERTICAL_SPACING = 196

export function getPlaceholderSubjectId(setId: string, slotIndex: number): string {
  return `${setId}:slot:${slotIndex}`
}

export function isPlaceholderSubjectId(id: string): boolean {
  return id.includes(':slot:')
}

export function createPlaceholderSubjectNodes(
  setId: string,
  assetId: string,
  sceneId: string,
  characters: PlaceholderCharacterInfo[],
): void {
  const { canvasPositions, subjectCanvasNodes, addSubjectCanvasNode, setCanvasPosition, authState } =
    useStore.getState()
  const setNodeId = `asset-${assetId}`
  const setPos = canvasPositions.get(setNodeId)
  if (!setPos) return

  const userId = authState?.userId ?? 'unknown'

  for (let i = 0; i < characters.length; i++) {
    const char = characters[i]
    const placeholderId = getPlaceholderSubjectId(setId, char.slotIndex)

    if (subjectCanvasNodes.has(placeholderId)) continue

    const node: SubjectCanvasNode = {
      id: placeholderId,
      sceneId,
      name: char.name,
      category: 'character',
      color: char.color,
      characterType: char.characterType,
      createdAt: new Date().toISOString(),
      createdBy: userId,
    }

    addSubjectCanvasNode(node)
    setCanvasPosition(`subject-${placeholderId}`, {
      x: setPos.x + SET_NODE_WIDTH + NODE_GAP_X,
      y: setPos.y + i * SUBJECT_VERTICAL_SPACING,
    })
  }
}

export function removePlaceholderSubjectNodes(setId: string, characters: PlaceholderCharacterInfo[]): void {
  const { removeSubjectCanvasNode } = useStore.getState()
  for (const char of characters) {
    const placeholderId = getPlaceholderSubjectId(setId, char.slotIndex)
    removeSubjectCanvasNode(placeholderId)
  }
}
